import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";
import { JsonLd } from "@/components/JsonLd";
import { Faq } from "@/components/Faq";
import { AdSlot } from "@/components/AdSlot";
import { WIDGETS } from "@/components/rechner/widgets";
import { RECHNER_SEITEN } from "@/lib/rechnerSeiten";

export default function RechnerPage({ seite }) {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const canonical = origin ? `${origin}/${seite.slug}` : undefined;
  const Widget = WIDGETS[seite.key];
  const andere = RECHNER_SEITEN.filter((s) => s.slug !== seite.slug);

  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "WebApplication",
      name: seite.h1,
      url: canonical,
      applicationCategory: "UtilityApplication",
      operatingSystem: "Web",
      offers: { "@type": "Offer", price: "0", priceCurrency: "EUR" },
      inLanguage: "de-DE",
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: seite.faq.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    },
  ];

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
      <Seo title={seite.title} description={seite.description} canonical={canonical} />
      <JsonLd data={jsonLd} />

      <h1 className="text-2xl sm:text-3xl font-semibold tracking-tight">{seite.h1}</h1>
      <p className="mt-3 text-muted-foreground leading-relaxed">{seite.intro}</p>

      <div className="mt-6">{Widget && <Widget />}</div>

      <div className="mt-8"><AdSlot variant="banner" /></div>

      <section className="mt-8">
        <h2 className="text-xl font-semibold mb-3">Weitere Rechner</h2>
        <ul className="grid sm:grid-cols-2 gap-2">
          {andere.map((s) => (
            <li key={s.slug}>
              <Link to={`/${s.slug}`} className="text-primary hover:underline">{s.name}</Link>
            </li>
          ))}
        </ul>
      </section>

      <section className="mt-10">
        <h2 className="text-xl font-semibold mb-4">Häufige Fragen</h2>
        <Faq items={seite.faq} testId="rechner-faq" />
      </section>

      <div className="mt-10"><AdSlot variant="banner" /></div>
    </div>
  );
}
